import { escapeAttr, escapeHtml, linkAttrs, } from "@emkit/builder-core";
export const PRODUCT_CARD_DEFAULTS = {
    imageUrl: "https://placehold.co/800x800/e5e7eb/6b7280?text=Product",
    imageAlt: "Product",
    title: "Product name",
    description: "Short description of the product that sets buyer expectations.",
    price: "$49",
    compareAtPrice: "$79",
    badge: "Sale",
    badgeColor: "#ef4444",
    ctaLabel: "Add to cart",
    ctaHref: "#",
    layout: "vertical",
    background: "#ffffff",
    textColor: "#0f172a",
    accent: "#111827",
    radius: 12,
};
export const productCardWidget = {
    type: "product-card",
    defaultProps: PRODUCT_CARD_DEFAULTS,
    renderHtml(props, ctx) {
        const img = ctx.resolveAssetUrl?.(props.imageUrl) ?? props.imageUrl;
        const layout = props.layout ?? "vertical";
        const bg = props.background ?? "#ffffff";
        const text = props.textColor ?? "#0f172a";
        const accent = props.accent ?? "#111827";
        const radius = props.radius ?? 12;
        const badgeColor = props.badgeColor ?? "#ef4444";
        const badge = props.badge
            ? `<div style="position:absolute;top:12px;left:12px;background:${badgeColor};color:#fff;padding:4px 10px;border-radius:999px;font-size:12px;font-weight:600;letter-spacing:0.02em;z-index:1">${escapeHtml(props.badge)}</div>`
            : "";
        const imageEl = `<div style="position:relative;${layout === "vertical" ? "aspect-ratio:1/1" : "width:45%;min-width:160px"};background:#f1f5f9;overflow:hidden;flex-shrink:0">${badge}<img src="${escapeAttr(img)}" alt="${escapeAttr(props.imageAlt ?? props.title)}" loading="lazy" decoding="async" style="display:block;width:100%;height:100%;object-fit:cover"></div>`;
        const price = props.compareAtPrice
            ? `<span style="font-size:18px;font-weight:700;color:${text}">${escapeHtml(props.price)}</span><span style="font-size:14px;color:${text};opacity:0.5;text-decoration:line-through;margin-left:8px">${escapeHtml(props.compareAtPrice)}</span>`
            : `<span style="font-size:18px;font-weight:700;color:${text}">${escapeHtml(props.price)}</span>`;
        const desc = props.description
            ? `<p style="margin:6px 0 0;font-size:14px;line-height:1.55;color:${text};opacity:0.7">${escapeHtml(props.description)}</p>`
            : "";
        const cta = `<a href="${escapeAttr(props.ctaHref)}"${linkAttrs(props.ctaHref, props.ctaTarget)} class="emk-product-cta" style="display:inline-flex;align-items:center;justify-content:center;padding:10px 18px;background:${accent};color:#fff;text-decoration:none;border-radius:8px;font-weight:500;font-size:14px;margin-top:auto">${escapeHtml(props.ctaLabel)}</a>`;
        const body = `<div style="padding:${layout === "vertical" ? "16px" : "20px"};display:flex;flex-direction:column;flex:1"><h3 style="margin:0;font-size:16px;font-weight:600;line-height:1.3;color:${text}">${escapeHtml(props.title)}</h3>${desc}<div style="display:flex;align-items:baseline;margin:12px 0 14px">${price}</div>${cta}</div>`;
        const wrapStyle = [
            "display:flex",
            layout === "horizontal" ? "flex-direction:row" : "flex-direction:column",
            `background:${bg}`,
            `border-radius:${radius}px`,
            "overflow:hidden",
            "border:1px solid rgba(0,0,0,0.08)",
            "font-family:inherit",
            "max-width:" + (layout === "horizontal" ? "640px" : "360px"),
        ].join(";");
        return `<div class="emk-product-card emk-product-card--${layout}" style="${wrapStyle}">${imageEl}${body}</div>`;
    },
};
//# sourceMappingURL=product-card.js.map